import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ConfirmationService, SelectItem} from "primeng/api";
import {ListaService} from "../../../_services/lista.service";
import {ListaItem} from "../../../_models/lista-item";
import {forkJoin} from "rxjs";
import {NavService} from "../../../_services/_nav.service";
import {PlataformasDigitalesValidaciones} from "../../../_models/plataformas-digitales-validaciones";
import {PlataformasDigitalesValidacionesService} from "../../../_services/plataformas-digitales-validaciones.service";
import {
  PlataformasDigitalesValidacionesFacetecService
} from "../../../_services/plataformas-digitales-validaciones-facetec.service";
import {PlataformasDigitalesValidacionesFacetec} from "../../../_models/plataformas-digitales-validaciones-facetec";

@Component({
  selector: 'app-flujo-venta-validacion-plataforma-digital',
  templateUrl: './flujo-venta-validacion-plataforma-digital.component.html',
})
export class FlujoVentaValidacionPlataformaDigitalComponent implements OnInit {
  carEstados = true;
  cargando = true;
  formulario: FormGroup;
  columnas: any[] = [];
  submitted = false;
  lisCausaSolicitudesTodos: ListaItem[];
  lisCausaSolicitudes: SelectItem[] = [];
  lisModoAutenticacionTodos: ListaItem[];
  lisModoAutenticacion: SelectItem[] = [];
  orden: number;
  plataformasDigitalesValidaciones: PlataformasDigitalesValidaciones;
  lisPlatFormDigVal: PlataformasDigitalesValidaciones[];
  listaCompleta: PlataformasDigitalesValidaciones[];

  pageActual: number = 0;
  mensajeReintento: string;

  constructor(private fb: FormBuilder,
              private lisService: ListaService,
              private navServicio: NavService,
              private conServicio: ConfirmationService,
              private pladigval: PlataformasDigitalesValidacionesService,
              private platDigValFacetec: PlataformasDigitalesValidacionesFacetecService) { }

  ngOnInit() {
    this.lisPlatFormDigVal = [];
    forkJoin(this.lisService.getMasterDetails("ListasCausalesSolicitudes"),
      this.lisService.getMasterDetails("ListasModosAutenticaciones"),
      this.pladigval.listadoHabilitados(),
      this.pladigval.listado()).subscribe(([liscausales, lisAutenticaciones, lisPlataformDig, listaToda]) => {
      this.lisCausaSolicitudesTodos = liscausales;
      this.lisModoAutenticacionTodos = lisAutenticaciones;
      this.lisPlatFormDigVal = lisPlataformDig;
      this.listaCompleta = listaToda;
      this.cargarCombos();
      this.cargarFormulario();
      this.carEstados = false;
      this.cargando = false;
      this.refrescar();
    });

    this.columnas = [];
    this.columnas = [
      { field: 'orden', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_ORDEN' ), sort: false },
      { field: 'nombreModoAutenticacion', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_VALIDACION' ), sort: false },
      { field: 'cantidadReintentos', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_REINTENTOS' ), sort: false },
      { field: 'indicadorReiniciarIntentos', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_REINICIARINTENTOS' ), sort: false },
      { field: 'nombreCausal', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_CAUSALFABRICA' ), sort: false },
      { field: 'nombreCausal', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_CAUSALDENEGACION' ), sort: false },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.LBL_ACCIONES' ), sort: false },
    ]
  }

  cargarCombos(){
    this.lisCausaSolicitudesTodos.map(s=>{
      this.lisCausaSolicitudes.push({label: s.nombre, value: s.idLista});
    });
    this.lisModoAutenticacionTodos.map(s=>{
      this.lisModoAutenticacion.push({label: s.nombre, value: s.idLista});
    });

  }

  editar(dato: PlataformasDigitalesValidaciones){
    this.plataformasDigitalesValidaciones = dato;
    this.platDigValFacetec.obtenerPorIdPlataDigiVal(dato.idPlataformaDigitalValidacion).subscribe(res => {
      this.cargarFormulario();
    });
    this.submitted = false;
    this.cargarFormulario();
  }

  inhabilitar(dato: PlataformasDigitalesValidaciones){
    dato.indicadorHabilitado = false;
    dato.orden = 0;
    this.pladigval.actualizar(dato).subscribe(s => {
      this.pladigval.listadoHabilitados().subscribe( r =>{
        const lista = r;
        let c = 1;
        lista.forEach( or => {
          or.orden = c;
          c++;
          this.pladigval.actualizar(or).subscribe(x => {

          });
        });
        this.navServicio.setMesage( 2 );
        this.refrescar();
      });
    });
  }

  refrescar(){
    this.carEstados = true;
    this.cargando = true;
    this.pladigval.listadoHabilitados().subscribe(res => {
      this.lisPlatFormDigVal = res;
      this.orden = this.lisPlatFormDigVal.length+1;
      this.plataformasDigitalesValidaciones = null;
      this.submitted = false;
      this.cargando = false;
      this.cargarFormulario();
      this.carEstados = false;
    });
    this.pladigval.listado().subscribe(res => {
      this.listaCompleta = res;
    });
  }
  cargarFormulario(){
    this.formulario = this.fb.group( {
      id: [ this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.id: null],
      idPlataformaDigitalValidacion: [ this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.idPlataformaDigitalValidacion: null],
      idModoAutenticacion: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.idModoAutenticacion: null, [Validators.required]],
      idCausal: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.idCausal: null],
      cantidadReintentos: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.cantidadReintentos: null],
      orden: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.orden: null],
      indicadorReintentos: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.indicadorReintentos: false],
      indicadorEnviarFabrica: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.indicadorEnviarFabrica: false],
      indicadorDeniega: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.indicadorDeniega: false],
      indicadorReiniciarIntentos: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.indicadorReiniciarIntentos: false],
      indicadorHabilitado: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.indicadorHabilitado: true],
      auditoriaUsuario: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.auditoriaUsuario: null],
      auditoriaFecha: [this.plataformasDigitalesValidaciones ? this.plataformasDigitalesValidaciones.auditoriaFecha: null],

    });
  }

  onSubmit(){
    this.submitted = true;
    if(this.formulario.valid && this.validar()){
      this.cargando = true;
      const registro = this.formulario.value;
      let temp = {} as PlataformasDigitalesValidaciones;
      if(this.plataformasDigitalesValidaciones){
        temp.idPlataformaDigitalValidacion = this.plataformasDigitalesValidaciones.idPlataformaDigitalValidacion;
        temp.orden = this.plataformasDigitalesValidaciones.orden;
      }else{
        const buscar = this.listaCompleta.find(x => x.idModoAutenticacion === this.f.idModoAutenticacion.value && !x.indicadorHabilitado);
        if(buscar){
          temp.idPlataformaDigitalValidacion = buscar.idPlataformaDigitalValidacion;
          temp.orden = this.orden;
        }
      }
      temp.idModoAutenticacion = registro.idModoAutenticacion;
      temp.indicadorReintentos = registro.indicadorReintentos;
      temp.cantidadReintentos = registro.cantidadReintentos;
      temp.indicadorHabilitado = true;
      temp.indicadorEnviarFabrica = registro.indicadorEnviarFabrica;
      temp.indicadorReiniciarIntentos = registro.indicadorReiniciarIntentos;
      temp.indicadorDeniega = registro.indicadorDeniega;
      temp.idCausal = registro.idCausal;
      if(temp.idPlataformaDigitalValidacion){
        this.pladigval.actualizar(temp).subscribe(obj =>{
          this.navServicio.setMesage( 2 );
          this.submitted = false;
          this.cargando = false;
          this.refrescar();
        }, error => {
          this.cargando = false;
          this.navServicio.setMesage( 3 );
        });
      }else{
        temp.orden = this.orden;
        this.pladigval.crear(temp).subscribe(obj => {
          this.navServicio.setMesage( 1 );
          this.submitted = false;
          this.cargando = false;
          this.refrescar();
        }, error => {
          this.cargando = false;
          this.navServicio.setMesage( 3 );
        });
      }
    }

  }

  validar(){
    if(this.validarCantidadReintentos() &&
      this.validarCausal() &&
      this.validarUnaSolaValidacion()){
      return true;
    }else{
      return false;
    }
  }

  validarCheckFabrica(){
    if(this.f.indicadorEnviarFabrica.value){
      this.f.indicadorDeniega.setValue(false);
    } else {
      this.f.indicadorReiniciarIntentos.setValue(false);
    }
  }

  validarCheckDeniega(){
    if(this.f.indicadorDeniega.value){
      this.f.indicadorEnviarFabrica.setValue(false);
      this.f.indicadorReiniciarIntentos.setValue(false);
    }
  }

  validarUnaSolaValidacion(){
    const buscar = this.lisPlatFormDigVal.find(x => x.idModoAutenticacion === this.f.idModoAutenticacion.value);
    if(buscar && !this.plataformasDigitalesValidaciones){
      this.showMessage('LBL_INFORMACION', 'FLUJOVENTAVALIDACIONES.MSG_YAEXISTE')
      return false;
    }else {
      return true;
    }
  }

  validarCantidadReintentos(){
    if(this.f.indicadorReintentos.value){
      if(this.f.cantidadReintentos.value){
        return true;
      }else{
        if(this.f.cantidadReintentos.value === 0){
          this.mensajeReintento = this.navServicio.buscarMensaje("FLUJOVENTAVALIDACIONES.LBL_MAYORACERO");
          return false;
        }else{
          this.mensajeReintento = this.navServicio.buscarMensaje("FLUJOVENTAVALIDACIONES.LBL_CITENTOS") + " " +
            this.navServicio.buscarMensaje("LBL_REQUERIDO");
          return false;
        }
      }
    }else{
      this.f.cantidadReintentos.setValue(0);
      return true;
    }
  }

  validarCausal(){
    if(this.f.indicadorDeniega.value || this.f.indicadorEnviarFabrica.value){
      if(this.f.idCausal.value){
        return true;
      }else{
        return false;
      }
    }else{
      this.showMessage('LBL_INFORMACION', 'FLUJOVENTAVALIDACIONES.MSG_ESPECIFIQUE');
      return false;
    }
  }

  private showMessage( titulo: string, mensaje: string, severity: string = 'info' ) {
    this.navServicio.setMesage( 0, {
      severity: severity, summary: this.navServicio.buscarMensaje( titulo ),
      detail: this.navServicio.buscarMensaje( mensaje )
    } );
  }

  get f(){
    return this.formulario.controls;
  }

  mensajeEliminar(dato: PlataformasDigitalesValidaciones){
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'FLUJOVENTAVALIDACIONES.MSG_ELIMINAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'flujo-venta-validacion-plataforma',
      accept: () => {
        this.inhabilitar(dato);
      },
      reject: () => {
      }
    } );
  }

  regresar(dirty: boolean){
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'flujo-venta-validacion-plataforma',
        accept: () => {
          this.salir( null );
          this.refrescar();
        },
        reject: () => {
        }
      } );
    } else {
      this.salir( null );
      this.refrescar();

    }
  }

  salir( mensaje: number ) {
    this.cargarFormulario();
    this.submitted = false;
    this.cargando = false;
    if ( mensaje !== null && mensaje !== undefined ) {
      this.navServicio.setMesage( mensaje );
    }
  }

  async cambiarOrden( item: any, subir: boolean ) {
    let miIndice = this.lisPlatFormDigVal.indexOf( item );
    if(subir){
      this.carEstados = true;
      const nueva = this.lisPlatFormDigVal[ miIndice ];
      nueva.orden = nueva.orden - 1;
      const actual = this.lisPlatFormDigVal[ miIndice - 1 ];
      actual.orden = actual.orden + 1;
      const lisActualizar = [];
      lisActualizar.push(nueva);
      lisActualizar.push(actual);
      lisActualizar.forEach(nuevoDato => {
        this.pladigval.actualizar(nuevoDato).subscribe(res => {
          this.refrescar();
        });
      });
    }else{
      this.carEstados = true;
      const nueva = this.lisPlatFormDigVal[ miIndice ];
      nueva.orden = nueva.orden + 1;
      const actual = this.lisPlatFormDigVal[ miIndice + 1 ];
      actual.orden = actual.orden - 1;
      const lisActualizar = [];
      lisActualizar.push(nueva);
      lisActualizar.push(actual);
      lisActualizar.forEach(nuevoDato => {
        this.pladigval.actualizar(nuevoDato).subscribe(res => {
          this.refrescar();
        });
      });
    }
  }

  paginaActual(event: any) {
    this.pageActual = event.first;
  }

}
